<template>
    <v-navigation-drawer class="filter-drawer" style="z-index: 10000" fixed v-model="dialog"
        v-stack="{ open: dialog, close: hide }" right temporary height="100vh" color="surface" :width="drawerWidth">
        <filter-coach-form @hide="hide"/>
    </v-navigation-drawer>
</template>

<script>

import teleportToAppRoot from '@/mixins/teleportToAppRoot'
import FilterCoachForm from "@/components/student/FilterCoachForm";

export default {
    components: {FilterCoachForm},
    mixins: [teleportToAppRoot],
    data() {
        return {
            dialog: false,
        }
    },
    computed: {
        drawerWidth(vm = this) {
            return vm.isMobile ? vm.$vuetify.breakpoint.width : 380
        },
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
        },
    },
}

</script>

<style scoped>

.filter-drawer {
    border-left: 1px solid var(--v-outline-base);
    box-shadow: -8px 0 40px rgba(0, 0, 0, 0.4);
}

.filter-drawer >>> .v-navigation-drawer__content {
    height: 100%;
    overflow: hidden;
}

</style>
